// extracted by mini-css-extract-plugin
export default {"container":"TerritoriesFilter_container__Z8pyS"};